import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import BaseButtons from "../../../base-buttons/BaseButtons";
import TextInputField from "../../../text-input-field/TextInputField";

import ImageUploadAWS from "../../../../user/components/image-upload/ImageUploadAWS";
import DropDownWithDisplay from "../../../drop-down-with-display/DropDownWithDisplay";
import TextInputFieldArea from "../../../text-input-field/TextInputFieldArea";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import BarcodeScannerPdf417 from "../barcode-scanner/BarcodeScannerPdf417";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const AddVehiclePopUp = ({
  display,
  onCloseClick,
  width,
  type,
  setMessage,
  setPopUpTitle,
  setToastPop,
  refresh,
  setRefresh,
  setLoading,
  user,
  auth,
  setVehicleAdd,
  height,
}) => {
  const [scanBarcode, setScanBarcode] = useState(false);
  const [registerNumber, setRegisterNumber] = useState("");
  const [liscenseNumber, setLiscenseNumber] = useState("");
  const [vinNumber, setVinNumber] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [make, setMake] = useState(null);
  const [series, setSeries] = useState(null);
  const [previousOwnerId, setPreviousOwnerId] = useState("");

  const [capturePath, setCapturePath] = useState("base");

  const [vehicleCategory, setVehicleCategory] = useState("");
  const [vehicleDriven, setVehicleDriven] = useState("");
  const [vehicleDescription, setVehicleDescription] = useState("");
  const [tareKg, setTareKg] = useState("");
  const [dateOfExpiry, setDateOfExpiry] = useState("none");
  const [
    dateOfLiabilityForFirstLiscensing,
    setDateOfLiabilityForFirstLiscensing,
  ] = useState("");
  const [vehicleStatus, setVehicleStatus] = useState("");
  const [reasonForDeregistration, setReasonForDeregistration] = useState("");
  const [last3LiscenseNr, setLast3LiscenseNr] = useState("");
  const [typeOfIdentification, setTypeOfIdentification] = useState("");
  const [identityNr, setIdentityNr] = useState("");
  const [name, setName] = useState("");
  const [dateOfIssue, setDateOfIssue] = useState("");
  const [
    confirmationReasonForDeregistration,
    setConfirmationReasonForDeregistration,
  ] = useState("none");
  const [transactionNr, setTransactionNr] = useState("");

  const [data, setData] = useState("Not Found");
  const [dataScaned, setDataScaned] = useState(null);

  const ClearData = () => {
    setRegisterNumber("");
    setLiscenseNumber("");
    setVinNumber("");
    setEngineNumber("");
    setMake(null);
    setSeries(null);
    setPreviousOwnerId("");
    setVehicleCategory("");
    setVehicleDriven("");
    setVehicleDescription("");
    setTareKg("");
    setDateOfExpiry("none");
    setDateOfLiabilityForFirstLiscensing("");
    setVehicleStatus("");
    setReasonForDeregistration("");
    setLast3LiscenseNr("");
    setIdentityNr("");
    setName("");
    setDateOfIssue("");
    setTransactionNr("");
  };

  const [makeArray, setMakeArray] = useState(null);

  const [seriesArray, setSeriesArray] = useState(null);

  const [opened, setOpened] = useState(null);
  const [selectedMake, setSelectedMake] = useState(null);

  const [image, setImage] = useState("");

  const [imageError, setImageError] = useState("");

  const [scannedData, setScannedData] = useState("");

  const [barcodeData, setBarcodeData] = useState(null);
  const [splitAraryScan, setSplitAraryScan] = useState(null);

  //text field set up for data set in scan rc1

  const [formCode, setFormCode] = useState(null);
  const [controlNumber, setControlNumber] = useState(null);
  const [registerNumberScan, setRegisterNumberScan] = useState(null);
  const [vehicleDescriptionScan, setVehicleDescriptionScan] = useState(null);
  const [vehicleMakeScan, setVehicleMakeScan] = useState(null);
  const [vehicleSeriesScan, setVehicleSeriesScan] = useState(null);
  const [vehicleVinScan, setVehicleVinScan] = useState(null);
  const [vehicleEngineScan, setVehicleEngineScan] = useState(null);
  const [vehicleStatusScan, setVehicleStatusScan] = useState(null);
  const [vehicleDateOfIssueScan, setVehicleDateOfIssueScan] = useState(null);
  const [ownerIdScan, setOwnerIdScan] = useState(null);
  const [vehicleOwnerNameScan, setVehicleOwnerNameScan] = useState(null);

  const handleDecode = (data) => {
    setScanBarcode(false);
    setScannedData(data);
  };

  const splitAndMapDataScan = async () => {
    if (barcodeData) {
      const myArray = await barcodeData.split("%");
      setSplitAraryScan(myArray);
      setFormCode(myArray[1]);
      setControlNumber(myArray[5]);
      setRegisterNumberScan(myArray[6]);
      setVehicleDescriptionScan(myArray[7]);
      setVehicleMakeScan(myArray[8]);
      setVehicleSeriesScan(myArray[9]);
      setVehicleVinScan(myArray[10]);
      setVehicleEngineScan(myArray[11]);

      setVehicleStatusScan(myArray[12]);
      setVehicleDateOfIssueScan(myArray[13]);

      setOwnerIdScan(myArray[15]);
      setVehicleOwnerNameScan(myArray[16]);
    }
  };

  const GetSeriesDataLinkedToMake = async (value) => {
    if (value) {
      setLoading(true);

      try {
        const response = await fetch(
          process.env.REACT_APP_BACKEND_URL + "/enatis/getSeriesMasterList",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              // Authorization: `bearer ${token}`,
            },
            body: JSON.stringify({
              make: value,
            }),
          }
        );

        const respnseData = await response.json();
        if (respnseData.data) {
          setSeriesArray(respnseData.data);
          setLoading(false);
          // setVehicleSearchArray(respnseData.enatisVehicles);
        }
      } catch (err) {
        setLoading(false);
        console.log("error", err);
      }
    }
  };
  const GetAllMakeData = async () => {
    await fetch(
      process.env.REACT_APP_BACKEND_URL + "/enatis/getMakeMasterList"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setMakeArray(resData.data);
      });
  };
  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setImage(file);
  };

  const CheckForm = () => {
    if (capturePath === "rc1") {
      return "rc1";
    } else if (capturePath === "mvl1") {
      return "mvl1";
    } else if (capturePath === "loc") {
      return "loc";
    } else if (capturePath === "vdc") {
      return "vdc";
    }
  };

  const CreateNewUserVehicle = async (e) => {
    setLoading(true);
    let file = image;

    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      setLoading(false);
      return;
    } else {
      setImageError("");
    }
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("vehicleOwnerUuid", auth.userId);
      formData.append("vehicleOwnerIdNumber", user.idNumber);
      formData.append("currentDriverUuid", auth.userId);
      formData.append("registerNumber", registerNumber);
      formData.append("liscenseNumber", liscenseNumber);
      formData.append("vinNumber", vinNumber);
      formData.append("engineNumber", engineNumber);
      formData.append("make", make);
      formData.append("series", series);
      formData.append("previousOwnerId", "coming soon");
      formData.append("type", CheckForm());
      formData.append("vehicleCategory", vehicleCategory);
      formData.append("vehicleDriven", vehicleDriven);
      formData.append("vehicleDescription", vehicleDescription);
      formData.append("tareKg", tareKg);
      formData.append("dateOfExpiry", dateOfExpiry);
      formData.append(
        "dateOfLiabilityForFirstLiscensing",
        dateOfLiabilityForFirstLiscensing
      );
      formData.append("vehicleStatus", vehicleStatus);
      formData.append("last3LiscenseNr", last3LiscenseNr);
      formData.append("typeOfIdentification", "ID DOCUMENT");
      formData.append("identityNr", identityNr);
      formData.append("name", name);
      formData.append("dateOfIssue", dateOfIssue);
      formData.append("reasonForDeregistration", reasonForDeregistration);
      formData.append(
        "confirmationReasonForDeregistration",
        confirmationReasonForDeregistration
      );
      formData.append("transactionNr", transactionNr);

      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/createUserVehicle",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        // setPrivateInfoPopUp(false);
        setVehicleAdd(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setRefresh(refresh ? false : true);
        setCapturePath("base");
        ClearData();
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const [resultText, setResultText] = useState("");

  const handleScan = (err, result) => {
    if (result && result.text !== resultText) {
      setResultText(result.text);
      setBarcodeData(result.text);
    }
  };

  const closeScanner = () => {
    setScanBarcode(false);
  };

  const ColorSwitch = () => {
    if (type === "consumer") {
      return colors.greenLight;
    } else if (type === "org") {
      return colors.primaryOrange;
    } else if (type === "agency") {
      return colors.primaryBlue;
    }
  };

  useEffect(() => {
    GetAllMakeData();
  }, []);
  useEffect(() => {
    splitAndMapDataScan();
  }, [barcodeData]);
  useEffect(() => {
    splitAndMapDataScan();
  }, []);
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: colors.white,
        position: "absolute",
        bottom: 0,
        zIndex: 100,
        transition: "all 0.3s",
        opacity: display ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: width > 899 ? 10 : 60,
          width: "100%",
          display: "flex",
          zIndex: 1,
        }}
      >
        <div style={{ width: 10 }} />
        {scanBarcode ? null : (
          <BaseButtons
            label={"X"}
            borderRadius={20}
            backgroundColor={colors.secondaryOrange}
            onClick={
              capturePath === "base"
                ? onCloseClick
                : () => setCapturePath("base")
            }
            width={40}
          />
        )}
        <div style={{ flex: 1 }} />
        {scanBarcode ? null : (
          <BaseButtons
            // disabled={true}
            label={"SCAN BARCODE"}
            borderRadius={4}
            backgroundColor={colors.secondaryOrange}
            onClick={() => setScanBarcode(true)}
            width={200}
          />
        )}
        <div style={{ width: 10 }} />
      </div>
      {scanBarcode ? (
        <div
          style={{
            flex: 1,

            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            overflowY: "hidden",
          }}
        >
          {barcodeData ? (
            <div
              style={{
                flex: 1,
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                overflowY: "scroll",
                overflowX: "hidden",
                scrollbarWidth: "none",
              }}
            >
              <div style={{ minHeight: 70 }} />
              {splitAraryScan
                ? splitAraryScan.map((item, index) => {
                    return <div key={index}>{item}</div>;
                  })
                : null}
              <TextInputField
                labelTitle={"Form code"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={formCode}
              />
              <TextInputField
                labelTitle={"Control number"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={controlNumber}
              />
              <TextInputField
                labelTitle={"Register number"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={registerNumberScan}
              />
              <TextInputField
                labelTitle={"Vehicle descriptions"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleDescriptionScan}
              />
              <TextInputField
                labelTitle={"Vehicle make"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleMakeScan}
              />
              <TextInputField
                labelTitle={"Vehicle series"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleSeriesScan}
              />
              <TextInputField
                labelTitle={"Vin number"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleVinScan}
              />
              <TextInputField
                labelTitle={"Engine number"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleEngineScan}
              />
              <TextInputField
                labelTitle={"Vehicle status"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleStatusScan}
              />
              <TextInputField
                labelTitle={"Date of issue"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleDateOfIssueScan}
              />

              <TextInputField
                labelTitle={"Owner Id"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={ownerIdScan}
              />
              <TextInputField
                labelTitle={"Owner name"}
                mini={true}
                size={280}
                invert={true}
                fontWeight={"normal"}
                fontColor={"#00000090"}
                borderColor={"#00000010"}
                readOnly={true}
                value={vehicleOwnerNameScan}
              />
              <div style={{ minHeight: 10 }} />
              <BaseButtons
                label={"REFRESH SCANNER"}
                onClick={() => setBarcodeData(null)}
                borderRadius={8}
                backgroundColor={colors.greenDark}
              />
            </div>
          ) : (
            <BarcodeScannerPdf417
              barcodeData={barcodeData}
              setBarcodeData={setBarcodeData}
              closeScanner={closeScanner}
            />
          )}
          {/* <p>{barcodeData}</p> */}
        </div>
      ) : (
        <div
          style={{
            flex: 1,

            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
            overflowY: "scroll",
          }}
        >
          <div style={{ paddingTop: 90 }} />

          {/* <TextInputField
            labelTitle={"ID NUMBER (AUTO GENERATED)"}
            mini={true}
            value={user ? user.idNumber : null}
            width={"100%"}
            size={"80%"}
          />

          <TextInputField
            labelTitle={"PREVIOUS OWNER ID"}
            mini={true}
            value={previousOwnerId}
            onChange={(e) => setPreviousOwnerId(e.target.value)}
            reqiredCheck={true}
            rule={previousOwnerId.length}
            count={13}
            width={"100%"}
            size={"80%"}
          />
        
          <TextInputField
            labelTitle={"REGISTER NR"}
            mini={true}
            value={registerNumber}
            onChange={(e) => setRegisterNumber(e.target.value)}
            reqiredCheck={true}
            rule={registerNumber.length}
            count={7}
            width={"100%"}
            size={"80%"}
          />
          <TextInputField
            labelTitle={"LISCENSE NR"}
            mini={true}
            value={liscenseNumber}
            onChange={(e) => setLiscenseNumber(e.target.value)}
            reqiredCheck={true}
            rule={liscenseNumber.length}
            count={9}
            width={"100%"}
            size={"80%"}
          />
          <TextInputField
            labelTitle={"VIN NR"}
            mini={true}
            value={vinNumber}
            onChange={(e) => setVinNumber(e.target.value)}
            reqiredCheck={true}
            rule={vinNumber.length}
            count={17}
            width={"100%"}
            size={"80%"}
          />
          <TextInputField
            labelTitle={"ENGINE NR"}
            mini={true}
            value={engineNumber}
            onChange={(e) => setEngineNumber(e.target.value)}
            reqiredCheck={true}
            rule={engineNumber.length}
            count={20}
            width={"100%"}
            size={"80%"}
          />
          <div style={{ flex: 1, width: "100%" }}>
            <DropDownWithDisplay
              isMobile={true}
              title={"MAKE"}
              tagline={"(Select the make of your vehicle)"}
              data={makeArray ? makeArray : []}
              selected={make}
              setSelected={setMake}
              opened={opened}
              setOpened={setOpened}
              makeDropDown={true}
              GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
              setLoading={setLoading}
              auth={auth}
              setMessage={setMessage}
              setRefresh={setRefresh}
              refesh={refresh}
              setToastPop={setToastPop}
              setPopUpTitle={setPopUpTitle}
              setSelectedMake={setSelectedMake}
              setSeries={setSeries}
            />
            {seriesArray && selectedMake === make ? (
              <DropDownWithDisplay
                isMobile={true}
                title={"SERIES"}
                tagline={"(Select your vehicles series)"}
                data={seriesArray ? seriesArray : []}
                selected={series}
                setSelected={setSeries}
                opened={opened}
                setOpened={setOpened}
                seriesDropDown={true}
                setLoading={setLoading}
                auth={auth}
                setMessage={setMessage}
                setRefresh={setRefresh}
                refesh={refresh}
                setToastPop={setToastPop}
                make={make}
                GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                setPopUpTitle={setPopUpTitle}
              />
            ) : null}
          </div> */}
          {/* <TextInputField labelTitle={"LINKED DRIVER"} mini={true} />
        <TextInputField labelTitle={"KEY HOLDER"} mini={true} /> */}
          {capturePath === "base" ? (
            <>
              <div
                style={{
                  marginTop: 30,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 22,
                }}
              >
                CAPTURE TO ADD VEHICLE
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <div
                  style={{ width: "90%", textAlign: "center", fontSize: 14 }}
                >
                  Before proceeding, please have your document ready and select
                  the appropriate option below that matches the document you
                  have on hand.
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"RC1 CERTIFICATE OF REGISTRATION"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={60}
                  onClick={() => setCapturePath("rc1")}
                  // onClick={() => CreateNewUserVehicle()}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"MVL1 MOTOR VEHICLE LICENCE AND LICENCE DISC"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={60}
                  onClick={() => setCapturePath("mvl1")}
                  disabled={true}
                  // onClick={() => CreateNewUserVehicle()}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={
                    "LOC MOTOR VEHICLE LICENCE, LICENCE DISC & ROADWORTHY CERTIFICATE AND OPERATOR CARD"
                  }
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={60}
                  onClick={() => setCapturePath("loc")}
                  disabled={true}
                  // onClick={() => CreateNewUserVehicle()}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"VDC CERTIFICATE OF DEREGISTRATION"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={60}
                  disabled={true}
                  onClick={() => setCapturePath("vdc")}
                />
              </div>
            </>
          ) : null}
          {capturePath === "rc1" ? (
            <>
              <div
                style={{
                  marginTop: 40,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                CERTIFICATE OF REGISTRATION
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle registration nr"}
                value={registerNumber}
                onChange={(e) => setRegisterNumber(e.target.value)}
                reqiredCheck={true}
                rule={registerNumber.length}
                count={7}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle liscense Nr"}
                value={liscenseNumber}
                onChange={(e) => setLiscenseNumber(e.target.value)}
                reqiredCheck={true}
                rule={liscenseNumber.length}
                count={12}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle identification nr. (VIN nr.)"}
                value={vinNumber}
                onChange={(e) => setVinNumber(e.target.value)}
                reqiredCheck={true}
                rule={vinNumber.length}
                count={17}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Engine nr."}
                value={engineNumber}
                onChange={(e) => setEngineNumber(e.target.value)}
                reqiredCheck={true}
                rule={engineNumber.length}
                count={20}
              />
              <DropDownWithDisplay
                isMobile={true}
                title={"MAKE"}
                tagline={"(Select the make of your vehicle)"}
                data={makeArray ? makeArray : []}
                selected={make}
                setSelected={setMake}
                opened={opened}
                setOpened={setOpened}
                makeDropDown={true}
                GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                setLoading={setLoading}
                auth={auth}
                setMessage={setMessage}
                setRefresh={setRefresh}
                refesh={refresh}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setSelectedMake={setSelectedMake}
                setSeries={setSeries}
              />
              {seriesArray && selectedMake === make ? (
                <DropDownWithDisplay
                  isMobile={true}
                  title={"SERIES"}
                  tagline={"(Select your vehicles series)"}
                  data={seriesArray ? seriesArray : []}
                  selected={series}
                  setSelected={setSeries}
                  opened={opened}
                  setOpened={setOpened}
                  seriesDropDown={true}
                  setLoading={setLoading}
                  auth={auth}
                  setMessage={setMessage}
                  setRefresh={setRefresh}
                  refesh={refresh}
                  setToastPop={setToastPop}
                  make={make}
                  GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                  setPopUpTitle={setPopUpTitle}
                />
              ) : null}
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle category"}
                value={vehicleCategory}
                onChange={(e) => setVehicleCategory(e.target.value)}
                reqiredCheck={true}
                rule={vehicleCategory.length}
                count={20}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Driven"}
                value={vehicleDriven}
                onChange={(e) => setVehicleDriven(e.target.value)}
                reqiredCheck={true}
                rule={vehicleDriven.length}
                count={20}
              />
              <TextInputFieldArea
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle description"}
                value={vehicleDescription}
                onChange={(e) => setVehicleDescription(e.target.value)}
                reqiredCheck={true}
                rule={vehicleDescription.length}
                count={150}
                height={100}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Tare (T) kg"}
                value={tareKg}
                onChange={(e) => setTareKg(e.target.value)}
                reqiredCheck={true}
                rule={tareKg.length}
                count={20}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Date of liability for first licensing"}
                value={dateOfLiabilityForFirstLiscensing}
                onChange={(e) =>
                  setDateOfLiabilityForFirstLiscensing(e.target.value)
                }
                reqiredCheck={true}
                rule={dateOfLiabilityForFirstLiscensing.length}
                count={9}
                placeholder={"day/month/year"}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle status"}
                value={vehicleStatus}
                onChange={(e) => setVehicleStatus(e.target.value)}
                reqiredCheck={true}
                rule={vehicleStatus.length}
                count={9}
                placeholder={"eg. Owned / leased / rebuild"}
              />
              <TextInputFieldArea
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Reason for Deregistration"}
                value={reasonForDeregistration}
                onChange={(e) => setReasonForDeregistration(e.target.value)}
                reqiredCheck={true}
                rule={reasonForDeregistration.length}
                count={150}
                height={100}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Last 3 licence nr."}
                value={last3LiscenseNr}
                onChange={(e) => setLast3LiscenseNr(e.target.value)}
                reqiredCheck={true}
                rule={last3LiscenseNr.length}
                count={3}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                TITLE HOLDER
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Type of identification"}
                value={"ID DOCUMENT"}
                readOnly={true}
                // onChange={(e) => setTypeOfIdentification(e.target.value)}
                // reqiredCheck={true}
                // rule={typeOfIdentification.length}
                // count={20}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Identification nr"}
                rule={identityNr.length}
                value={identityNr}
                onChange={(e) => setIdentityNr(e.target.value)}
                reqiredCheck={true}
                count={13}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Name "}
                // rule={identityNr.length}
                value={name}
                onChange={(e) => setName(e.target.value)}
                // reqiredCheck={true}
                // count={13}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Date of issue"}
                value={dateOfIssue}
                onChange={(e) => setDateOfIssue(e.target.value)}
                reqiredCheck={true}
                rule={dateOfIssue.length}
                count={9}
                placeholder={"day/month/year"}
              />
              {/* <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Reason for Deregistration"}
                count={20}
                reqiredCheck={true}
                rule={0}
              /> */}
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                RECEIPT
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Transaction"}
                value={transactionNr}
                onChange={(e) => setTransactionNr(e.target.value)}
                reqiredCheck={true}
                rule={transactionNr.length}
                count={12}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                UPLOAD DOCUMENT
              </div>
              <ImageUploadAWS
                onChange={(e) => handleFileChange(e)}
                labelTitle={"Upload Motor Vehicle Documents"}
                mini={true}
                errorDisplay={imageError}
                width={"100%"}
                size={"80%"}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"SAVE VEHICLE DATA"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={50}
                  onClick={() => CreateNewUserVehicle()}
                />
              </div>
            </>
          ) : null}
          {/* {capturePath === "mvl1" ? (
            <>
              <div
                style={{
                  marginTop: 40,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "85%" }}>
                  MOTOR VEHICLE LICENCE AND LICENCE DISC
                </div>
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle registration nr"}
                count={7}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Licence Nr."}
                count={7}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle identification nr. (VIN nr.)"}
                count={17}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Engine nr."}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <DropDownWithDisplay
                isMobile={true}
                title={"MAKE"}
                tagline={"(Select the make of your vehicle)"}
                data={makeArray ? makeArray : []}
                selected={make}
                setSelected={setMake}
                opened={opened}
                setOpened={setOpened}
                makeDropDown={true}
                GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                setLoading={setLoading}
                auth={auth}
                setMessage={setMessage}
                setRefresh={setRefresh}
                refesh={refresh}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setSelectedMake={setSelectedMake}
                setSeries={setSeries}
              />
              {seriesArray && selectedMake === make ? (
                <DropDownWithDisplay
                  isMobile={true}
                  title={"SERIES"}
                  tagline={"(Select your vehicles series)"}
                  data={seriesArray ? seriesArray : []}
                  selected={series}
                  setSelected={setSeries}
                  opened={opened}
                  setOpened={setOpened}
                  seriesDropDown={true}
                  setLoading={setLoading}
                  auth={auth}
                  setMessage={setMessage}
                  setRefresh={setRefresh}
                  refesh={refresh}
                  setToastPop={setToastPop}
                  make={make}
                  GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                  setPopUpTitle={setPopUpTitle}
                />
              ) : null}
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle category"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Driven"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle description"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Tare (T) kg"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />

              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Last 3 licence nr."}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                RECEIPT
              </div>

              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Transaction"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                UPLOAD DOCUMENT
              </div>
              <ImageUploadAWS
                onChange={(e) => handleFileChange(e)}
                labelTitle={"Upload Motor Vehicle Documents"}
                mini={true}
                errorDisplay={imageError}
                width={"100%"}
                size={"80%"}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"SAVE VEHICLE DATA"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={50}
                  // onClick={() => setCapturePath("rc1")}
                  // onClick={() => CreateNewUserVehicle()}
                />
              </div>
            </>
          ) : null}
          {capturePath === "vdc" ? (
            <>
              <div
                style={{
                  marginTop: 40,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                CERTIFICATE OF DEREGISTRATION VDC
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle registration nr"}
                count={7}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle identification nr. (VIN nr.)"}
                count={17}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Engine nr."}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <DropDownWithDisplay
                isMobile={true}
                title={"MAKE"}
                tagline={"(Select the make of your vehicle)"}
                data={makeArray ? makeArray : []}
                selected={make}
                setSelected={setMake}
                opened={opened}
                setOpened={setOpened}
                makeDropDown={true}
                GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                setLoading={setLoading}
                auth={auth}
                setMessage={setMessage}
                setRefresh={setRefresh}
                refesh={refresh}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setSelectedMake={setSelectedMake}
                setSeries={setSeries}
              />
              {seriesArray && selectedMake === make ? (
                <DropDownWithDisplay
                  isMobile={true}
                  title={"SERIES"}
                  tagline={"(Select your vehicles series)"}
                  data={seriesArray ? seriesArray : []}
                  selected={series}
                  setSelected={setSeries}
                  opened={opened}
                  setOpened={setOpened}
                  seriesDropDown={true}
                  setLoading={setLoading}
                  auth={auth}
                  setMessage={setMessage}
                  setRefresh={setRefresh}
                  refesh={refresh}
                  setToastPop={setToastPop}
                  make={make}
                  GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                  setPopUpTitle={setPopUpTitle}
                />
              ) : null}
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle category"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Driven"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle description"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Tare (T) kg"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Date of liability for first licensing"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle status"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Reason for Deregistration"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Last 3 licence nr."}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                TITLE HOLDER
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Type of identification"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Identification nr"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Name "}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Date of issue"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Reason for Deregistration"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                RECEIPT
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Transaction"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                UPLOAD DOCUMENT
              </div>
              <ImageUploadAWS
                onChange={(e) => handleFileChange(e)}
                labelTitle={"Upload Motor Vehicle Documents"}
                mini={true}
                errorDisplay={imageError}
                width={"100%"}
                size={"80%"}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"SAVE VEHICLE DATA"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={50}
                  // onClick={() => setCapturePath("rc1")}
                  // onClick={() => CreateNewUserVehicle()}
                />
              </div>
            </>
          ) : null}
          {capturePath === "loc" ? (
            <>
              <div
                style={{
                  marginTop: 40,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "85%" }}>
                  MOTOR VEHICLE LICENCE AND LICENCE DISC LOC
                </div>
              </div>
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle registration nr"}
                count={7}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Licence Nr."}
                count={7}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle identification nr. (VIN nr.)"}
                count={17}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Engine nr."}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <DropDownWithDisplay
                isMobile={true}
                title={"MAKE"}
                tagline={"(Select the make of your vehicle)"}
                data={makeArray ? makeArray : []}
                selected={make}
                setSelected={setMake}
                opened={opened}
                setOpened={setOpened}
                makeDropDown={true}
                GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                setLoading={setLoading}
                auth={auth}
                setMessage={setMessage}
                setRefresh={setRefresh}
                refesh={refresh}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setSelectedMake={setSelectedMake}
                setSeries={setSeries}
              />
              {seriesArray && selectedMake === make ? (
                <DropDownWithDisplay
                  isMobile={true}
                  title={"SERIES"}
                  tagline={"(Select your vehicles series)"}
                  data={seriesArray ? seriesArray : []}
                  selected={series}
                  setSelected={setSeries}
                  opened={opened}
                  setOpened={setOpened}
                  seriesDropDown={true}
                  setLoading={setLoading}
                  auth={auth}
                  setMessage={setMessage}
                  setRefresh={setRefresh}
                  refesh={refresh}
                  setToastPop={setToastPop}
                  make={make}
                  GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                  setPopUpTitle={setPopUpTitle}
                />
              ) : null}
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle category"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Driven"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Vehicle description"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Tare (T) kg"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />

              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Date of expiry"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                RECEIPT
              </div>

              <TextInputField
                width={"100%"}
                size={"80%"}
                mini={true}
                labelTitle={"Transaction"}
                count={20}
                reqiredCheck={true}
                rule={0}
              />
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                UPLOAD DOCUMENT
              </div>
              <ImageUploadAWS
                onChange={(e) => handleFileChange(e)}
                labelTitle={"Upload Motor Vehicle Documents"}
                mini={true}
                errorDisplay={imageError}
                width={"100%"}
                size={"80%"}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: 20,
                }}
              >
                <BaseButtons
                  label={"SAVE VEHICLE DATA"}
                  width={"90%"}
                  borderRadius={4}
                  backgroundColor={colors.greenLight}
                  height={50}
                  // onClick={() => setCapturePath("rc1")}
                  // onClick={() => CreateNewUserVehicle()}
                />
              </div>
            </>
          ) : null} */}
        </div>
      )}
    </div>
  );
};

export default AddVehiclePopUp;
